export default [
  {
    path: '/trainingHome',
    name: 'trainingHome',
    component: () => import('@views/training/home.vue'),
    meta: {
      title: '学习培训首页'
    }
  },
  {
    path: '/trainingAdd',
    name: 'trainingAdd',
    component: () => import('@views/training/add.vue'),
    meta: {
      title: '详情'
    }
  },
  {
    path: '/training',
    name: 'training',
    component: () => import('@views/training/index.vue'),
    meta: {
      title: '学习培训'
    }
  },

  // --------------工伤预防----------------
  {
    path: '/injury',
    name: 'injury',
    component: () => import('@views/injury/index.vue'),
    meta: {
      title: '工伤预防项目'
    }
  },
  {
    path: '/injury/info',
    name: 'injuryInfo',
    component: () => import('@views/injury/info/index.vue'),
    meta: {
      title: '工伤预防视频'
    }
  },
  {
    path: '/injury/statistics',
    name: 'statistics',
    component: () => import('@views/injury/statistics/index.vue'),
    meta: {
      title: '工伤预防视频'
    }
  },
  {
    path: '/injury/detail',
    name: 'statistics',
    component: () => import('@views/injury/detail/index.vue'),
    meta: {
      title: '工伤预防视频'
    }
  },
]
